import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProvincialView from '../views/ProvincialView.vue'
import NationalView from '../views/NationalView.vue'

// 分省页面
import DemandView from '../views/DemandView.vue'
import ResultsView from '../views/ResultsView.vue'
import SupplyView from '../views/SupplyView.vue'
import CompareView from '../views/CompareView.vue'

// 全国页面
import NationalDemandView from '../views/NationalDemandView.vue'
import NationalResultsView from '../views/NationalResultsView.vue'
import NationalSupplyView from '../views/NationalSupplyView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 全国路由
  {
    path: '/national',
    name: 'national',
    component: NationalView,
    meta: { title: '全国能源供需' }
  },
  {
    path: '/national/demand',
    name: 'nationalDemand',
    component: NationalDemandView,
    meta: { title: '全国模型参数输入' }
  },
  {
    path: '/national/results',
    name: 'nationalResults',
    component: NationalResultsView,
    meta: { title: '全国能源需求预测' }
  },
  {
    path: '/national/supply',
    name: 'nationalSupply',
    component: NationalSupplyView,
    meta: { title: '全国能源供应分析' }
  },
  
  // 分省路由
  {
    path: '/provincial',
    name: 'provincial',
    component: ProvincialView,
    meta: { title: '分省能源供需' }
  },
  {
    path: '/provincial/demand',
    name: 'provincialDemand',
    component: DemandView,
    meta: { title: '分省模型参数输入' }
  },
  {
    path: '/provincial/results',
    name: 'provincialResults',
    component: ResultsView,
    meta: { title: '分省能源需求预测' }
  },
  {
    path: '/provincial/supply',
    name: 'provincialSupply',
    component: SupplyView,
    meta: { title: '分省能源供应分析' }
  },
  {
    path: '/provincial/compare',
    name: 'provincialCompare',
    component: CompareView,
    meta: { title: '分省区域协调评价' }
  },
  
  // 兼容旧的直接链接（可选，为了避免旧链接失效）
  {
    path: '/demand',
    redirect: '/provincial/demand'
  },
  {
    path: '/results',
    redirect: '/provincial/results'
  },
  {
    path: '/supply',
    redirect: '/provincial/supply'
  },
  {
    path: '/compare',
    redirect: '/provincial/compare'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 